import { render } from "./AppTag.vue?vue&type=template&id=f8981786&scoped=true"
import script from "./AppTag.vue?vue&type=script&lang=js"
export * from "./AppTag.vue?vue&type=script&lang=js"

import "./AppTag.vue?vue&type=style&index=0&id=f8981786&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8981786"]])

export default __exports__